/** @type {import('vuex').GetterTree<any, neptune.IRootState>} */
const getters = {
  // user id is not needed anywhere
  // UserId(_,__,rootState) {
  //     return rootState.payment.UserId
  // }
};

export default getters;
